import { usePrevious } from './use-previous';
import { useEffect } from 'react';
export function useFocusWhen(fn, focusableElement) {
  const val = fn();
  const previousVal = usePrevious(val);
  useEffect(() => {
    if (val && previousVal === false) {
      var _focusableElement$cur;
      focusableElement == null || (_focusableElement$cur = focusableElement.current) == null || _focusableElement$cur.focus();
    }
  }, [val, previousVal, focusableElement]);
}
//# sourceMappingURL=use-focus-when.js.map